import React, { useContext, useEffect } from "react";
import { WidgetContext } from "../../../../contexts/widgetContext";
import { RouterContext } from "../../../../contexts/routerContext";

import LogoWidget from "../../../../assets/images/logo.svg";
import Aside from "../aside";

import { Container, Content, Widget } from "./styles";
import { echo } from "../../../../services/socket";

const Webphone = ({ children }) => {
  const { open, setOpen } = useContext(WidgetContext);
  const { setRouter, setRouterParams } = useContext(RouterContext);

  useEffect(() => {
    const userLogged = sessionStorage.getItem("attendant");
    if (userLogged) {
      const socketConnect = echo();
      bindNotifications(socketConnect, userLogged);
    }
  }, []);

  const bindNotifications = (socketConnect, userLogged) => {
    socketConnect
      .channel("private-user." + userLogged)
      .listen(".WebphoneIntegration", (e) => {
        console.log("recebendo requisição!");
        setOpen(true);
        if (e.channelType === "CALL") {
          setRouter("make-a-call");
          setRouterParams(e);
        }
        if (e.channelType === "SMS") {
          setRouter("send-messages");
          setRouterParams(e);
        }
        if (e.channelType === "E-MAIL") {
          setRouter("send-messages");
          setRouterParams(e);
        }
        if (e.channelType === "WHATSAPP") {
          setRouter("send-messages");
          setRouterParams(e);
        }
      });
  };

  return (
    <>
      <Widget
        src={LogoWidget}
        alt="Widget do webphone"
        open={!open}
        onClick={() => setOpen(!open)}
      />
      <Container open={open}>
        <Aside />
        <Content>{children}</Content>
      </Container>
    </>
  );
};

export default Webphone;
